import { SET_AROUSAL_SCORES } from "./types";

const setArousalScores = (lowScore, mediumScore, highScore) => async (dispatch, getState) => {
    dispatch({
        type: SET_AROUSAL_SCORES,
        arousalLowScore: lowScore,
        arousalMediumScore: mediumScore,
        arousalHighScore: highScore,
    });
};

export default setArousalScores;
